(function($){
    // Section-header
    $(window).scroll(function() {
        var winST = $(window).scrollTop();
        var pad = parseInt($('.content-top').css('padding-top'));
        if (winST > pad) {
            $('.no-touch .section-header').fadeIn(250);
        } else {
            $('.no-touch .section-header').fadeOut(250);
        }
    });
    $('.no-touch .section-header').hover(function() {
        $(this).fadeOut(250);
    });
})(jQuery);
